import { Link } from 'react-router-dom';
import { useApplicationStore } from '@data';
import { ArrowRightIcon, Button } from '@quickmd-llc/design-system';
import {
  ContextHeading,
  PageHeading,
  Paragraph,
} from '@quickmd-llc/design-system';
import { SERVICES_ROUTE_PATHNAME } from '@router/routes/routePathnames';
import { useRefillCheckup } from '../hooks/useRefillCheckup';

export function RefillsSlide() {
  const { nextSlide } = useRefillCheckup();
  const activeRefill = useApplicationStore(
    ({ patient }) => patient.activeRefill,
  );
  const patientProfile = useApplicationStore(
    ({ patient }) => patient.patientProfile,
  );

  return (
    <>
      <div className="mb-4">
        <PageHeading className="mb-1">Refill your last medication</PageHeading>
        <Paragraph className="text-shade-80">
          Choose how you want continue your journey towards better health.
        </Paragraph>
      </div>

      <Paragraph className="mb-2 font-semibold text-shade-95">
        How do you want to continue?
      </Paragraph>

      <div className="grid gap-2">
        {activeRefill && (
          <Link to="" onClick={nextSlide}>
            <div className="flex items-center justify-between gap-3 break-words rounded-lg border border-shade-10 bg-white p-4">
              <div>
                <ContextHeading className="mb-2">
                  Refill your current dosage
                </ContextHeading>

                <Paragraph size="sm" className="text-shade-70">
                  {`Get a refill for ${activeRefill.name}.`}
                </Paragraph>
                <Paragraph size="sm" className="text-shade-70">
                  {`(${activeRefill.remainingRefillQuantity} remaining)`}
                </Paragraph>
              </div>

              <Button size="s" className="flex-shrink-0">
                <ArrowRightIcon />
              </Button>
            </div>
          </Link>
        )}

        <Link
          to={`${SERVICES_ROUTE_PATHNAME}?state=${patientProfile?.address.stateCode || ''}`}
          className="group"
        >
          <div className="flex items-center justify-between gap-3 break-words rounded-lg border border-shade-10 bg-white p-4">
            <div>
              <ContextHeading className="mb-2">
                Book a consultation
              </ContextHeading>

              <Paragraph
                size="sm"
                className="whitespace-pre-line text-shade-70"
              >
                At no extra charge, talk to a doctor for treatment
                modifications.
              </Paragraph>
            </div>

            <Button size="s" className="flex-shrink-0">
              <ArrowRightIcon />
            </Button>
          </div>
        </Link>
      </div>
    </>
  );
}
